import React, { useState } from 'react';
import { ArrowLeft, ChevronRight, LogOut } from 'lucide-react';
import { ADMIN_NAV_GROUPS, ADMIN_ROUTE_META, type AdminRoute } from './adminNavigation';
interface AdminSidebarProps {
  activeRoute: AdminRoute;
  onNavigate: (route: AdminRoute) => void;
  onLogout?: () => void;
  onReturnHome?: () => void;
}
export function AdminSidebar({
  activeRoute,
  onNavigate,
  onLogout,
  onReturnHome
}: AdminSidebarProps) {
  const [collapsed, setCollapsed] = useState(false);
  return <aside className={`flex flex-col bg-white border-r border-gray-200 transition-all duration-200 flex-shrink-0 h-full ${collapsed ? 'w-14' : 'w-56'}`} data-id="element-4280" data-mp="1fezqy5t5dsx6">
      {/* Header */}
      <div className={`flex items-center border-b border-gray-100 flex-shrink-0 ${collapsed ? 'justify-center px-2 py-4' : 'justify-between px-4 py-4'}`} data-id="element-4281" data-mp="1p51coqy12z8x">
        {!collapsed && <div className="flex items-center gap-2.5" data-id="element-4282" data-mp="1z38pcxlaav54">
            <div className="w-7 h-7 bg-gradient-to-br from-indigo-600 to-violet-600 rounded-lg flex items-center justify-center shadow-sm" data-id="element-4283" data-mp="1z3ql7t41b7ci">
              <span className="text-white font-black text-sm" data-id="element-4284" data-mp="28i1vfosdre6r">M</span>
            </div>
            <div data-id="element-4285" data-mp="23ipc3e0pwp8x">
              <div className="text-sm font-bold text-gray-900 leading-tight" data-id="element-4286" data-mp="23i5rfpjonmr7">
                Admin
              </div>
              <div className="text-[10px] uppercase tracking-wider text-gray-500 font-semibold" data-id="element-4287" data-mp="1zi5g4drvrrod">
                Beheercentrum
              </div>
            </div>
          </div>}
        <button onClick={() => setCollapsed(c => !c)} className="p-1.5 rounded-lg text-gray-400 hover:text-gray-600 hover:bg-gray-100 transition-colors focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:outline-none" aria-label={collapsed ? 'Uitklappen' : 'Inklappen'} data-id="element-4288" data-mp="2r80343s9n59v">
          <ChevronRight className={`w-4 h-4 transition-transform ${collapsed ? '' : 'rotate-180'}`} data-id="element-4289" data-mp="3eynptv6ubzgh" />
        </button>
      </div>

      {/* Navigation */}
      <nav className="flex-1 overflow-y-auto py-3 px-2" data-id="element-4290" data-mp="189bzheixqste">
        {ADMIN_NAV_GROUPS.map((group, index) => <div key={group.label} className="mb-4" data-id="element-4291" data-mp="1d7n8xo5bj1b3" data-mpi={index}>
            {!collapsed && <>
                {index > 0 && <div className="h-px bg-gray-100 mx-2 mb-3" data-id="element-4292" data-mp="yj97nhnjvkwn" />}
                <div className="px-2 mb-1.5" data-id="element-4293" data-mp="13iddbyb9n0i8">
                  <span className="text-[10px] font-bold text-gray-400 uppercase tracking-wider" data-id="element-4294" data-mp="13h2emcwogixz">
                    {group.label}
                  </span>
                </div>
              </>}
            <div className="space-y-0.5" data-id="element-4295" data-mp="ug455f3gzj80">
              {group.items.map(item => {
            const isActive = activeRoute === item.id;
            const Icon = item.icon;
            return <button key={item.id} onClick={() => onNavigate(item.id)} title={collapsed ? item.label : undefined} className={`w-full flex items-center gap-2.5 rounded-lg transition-colors relative focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:outline-none ${collapsed ? 'justify-center px-2 py-2.5' : 'px-2.5 py-2'} ${isActive ? 'bg-blue-50/50 text-blue-700' : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'}`} data-id="element-4296" data-mp="klud5yifwmxt">
                    {isActive && <div className="absolute left-0 top-1.5 bottom-1.5 w-1 bg-blue-600 rounded-r-full" data-id="element-4297" data-mp="88gv9hl0s85k" />}
                    <Icon className={`w-4 h-4 flex-shrink-0 ${isActive ? 'text-blue-600' : ''}`} data-id="element-4298" data-mp="hzlbslqcg12i" />
                    {!collapsed && <span className={`text-sm truncate ${isActive ? 'font-medium' : ''}`} data-id="element-4299" data-mp="vx9v3p4rj05g">
                        {item.label}
                      </span>}
                  </button>;
          })}
            </div>
          </div>)}
      </nav>

      {/* Footer */}
      <div className={`flex-shrink-0 border-t border-gray-100 ${collapsed ? 'p-2' : 'p-3'}`} data-id="element-4300" data-mp="2u7rxs7sj6knw">
        {/* Settings footer stays pinned while using the shared route metadata. */}
        {(() => {
        const settingsItem = ADMIN_ROUTE_META.settings;
        const SettingsIcon = settingsItem.icon;
        const isSettingsActive = activeRoute === settingsItem.id;
        return <button onClick={() => onNavigate(settingsItem.id)} title={collapsed ? settingsItem.label : undefined} className={`w-full flex items-center gap-2.5 rounded-lg transition-colors mb-3 relative focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:outline-none ${collapsed ? 'justify-center px-2 py-2.5' : 'px-2.5 py-2'} ${isSettingsActive ? 'bg-blue-50/50 text-blue-700' : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'}`} data-id="element-4301" data-mp="2bjmwr839ddss">
              {isSettingsActive && <div className="absolute left-0 top-1.5 bottom-1.5 w-1 bg-blue-600 rounded-r-full" data-id="element-4302" data-mp="1xokmk8rdp2a6" />}
              <SettingsIcon className={`w-4 h-4 ${isSettingsActive ? 'text-blue-600' : ''}`} data-id="element-4303" data-mp="auh0owipnbrw" />
              {!collapsed && <span className={`text-sm ${isSettingsActive ? 'font-medium' : ''}`} data-id="element-4304" data-mp="5t9swxgkicl8">
                  {settingsItem.label}
                </span>}
            </button>;
      })()}

        {onLogout && <button onClick={onLogout} className={`w-full flex items-center justify-center gap-2 rounded-lg text-gray-500 hover:text-red-600 hover:bg-red-50 transition-colors focus-visible:ring-2 focus-visible:ring-red-500 focus-visible:outline-none ${collapsed ? 'p-2' : 'px-3 py-2 text-sm font-medium'}`} title={collapsed ? 'Uitloggen' : undefined} data-id="element-4305" data-mp="3najk7l5mls71">
            <LogOut className="w-4 h-4" data-id="element-4306" data-mp="34drrym83w2qu" />
            {!collapsed && 'Uitloggen'}
          </button>}

        {onReturnHome && <button onClick={onReturnHome} className={`w-full flex items-center justify-center gap-2 rounded-lg text-gray-500 hover:text-gray-900 hover:bg-gray-50 transition-colors focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:outline-none ${collapsed ? 'p-2' : 'px-3 py-2 text-sm font-medium'}`} title={collapsed ? 'Terug naar Home' : undefined} data-id="element-4307" data-mp="2ur7culhvv4fy">
            <ArrowLeft className="w-4 h-4" data-id="element-4308" data-mp="3dhyipd2nwcpl" />
            {!collapsed && 'Terug naar Home'}
          </button>}
      </div>
    </aside>;
}